const DAY_MS = 24 * 60 * 60 * 1000;

export const getTrialDaysLeft = (expires?: string | number | null): number =>
  expires ? Math.max(0, Math.ceil((Number(expires) - Date.now()) / DAY_MS)) : 0;

// reactivationDeadline is unix SECONDS (Stripe convention on the status endpoint)
export const getClaimDaysLeft = (deadline?: number | null): number =>
  deadline
    ? Math.max(0, Math.ceil((deadline * 1000 - Date.now()) / DAY_MS))
    : 0;

// The claim window is 7 days from expiry, so days-since falls out of the deadline
export const getDaysSinceExpiry = (deadline?: number | null): number =>
  deadline ? Math.max(0, 7 - getClaimDaysLeft(deadline)) : 0;
